<template>
  <div>
    <v-btn
      color="red darken-4"
      fixed
      top
      right
      fab
      small
      @click="open(true)"
      v-if="visibleBoton"
      data-cy="btnOpenCarrito"
    >
      <v-badge color="red">
        <template v-slot:badge>
          <span class="caption">{{ cantServicios }}</span>
        </template>
        <v-icon color="white">
          shopping_cart
        </v-icon>
      </v-badge>
    </v-btn>
    <v-dialog v-model="isOpen" width="600px" persistent scrollable>
      <v-card>
        <v-card-title class="headline red darken-4" primary-title>
          <p class="text-white">
            Usted ha seleccionado
          </p>
        </v-card-title>
        <v-card-text>
          <Carrito />
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-container class="py-1" fluid>
            <v-layout row wrap>
              <v-flex xs12 sm6 class="pa-1 " grow>
                <v-btn color="primary" @click="open(false)" block class="caption">
                  Seguir comprando
                </v-btn>
              </v-flex>
              <v-flex xs12 sm6 class="pa-1" v-if="boton.visible">
                <v-btn data-cy="continuarBtn" block v-bind:class="boton.classObject" class="white--text" @click="goTo">
                  {{ boton.texto }}
                </v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import Carrito from "@/components/utiles/Carrito.vue"
export default {
  name: "modalCarrito",
  components: {
    Carrito
  },
  mounted() {
    //   this.$router.push({name: 'cuposAereos'});
  },
  beforeCreate() {},
  methods: {
    goTo() {
      this.$router.push({ name: this.boton.goto })
      this.open(false)
    },
    setBotonVisible(routeName) {
      switch (routeName) {
        case "resultadoHoteles":
        case "adicionalesHoteleria":
        case "hotelesCupos":
        case "resultadoPases":
        case "pasajerosCupoAgencias":
          this.visibleBoton = true
          break
        default:
          this.visibleBoton = false
          break
      }
    },
    open(valor) {
      this.$store.commit("carrito/setOpen", valor)
    }
  },
  computed: {
    ...mapGetters("carrito", {
      servicios: "cartServicios",
      cantServicios: "getCantidadServicios",
      boton: "getBoton",
      isOpen: "getOpen"
    })
  },
  data() {
    return {
      visibleBoton: false
    }
  },
  watch: {
    $route(to) {
      this.setBotonVisible(to.name)
    }
  }
}
</script>
